<template>
  <v-container fluid>
    <BreadHeader :title="`Restore ${modelName}`"></BreadHeader>
    <AError :api="api" />
    <v-card>
      <v-card-text>
        <span
          >Are you sure you want to restore <b>{{ `${modelName}` }}</b
          >?</span
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$router.go(-1)"> Cancel </v-btn>
        <v-btn :isLoading="api.isLoading" color="primary" @click="api.fetch()">
          Restore
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Api from "@/objects/api";
import BreadcrumbTabulator from "@/objects/breadcrumbTabulator";
import Model from "@/objects/model";
import Service from "@/objects/service";
import { mapState } from "vuex";

export default {
  computed: mapState({
    services: (state) => state.service.data.services,
  }),
  data: () => ({
    api: new Api(),
    breadcrumbTabulator: new BreadcrumbTabulator(),
    model: new Model(),
    modelId: null,
    modelName: null,
    service: new Service(),
    restoreUrl: "",
  }),
  created() {
    this.model.getByKey(this.$route.params.modelKey);
    this.modelId = this.$route.params.modelId;
    this.modelName = `${this.model.name.singular} ${this.modelId}`;
    if (this.model.serviceKey) this.service.set("key", this.model.serviceKey);
    this.breadcrumbTabulator.addForOperationRead({
      services: this.services,
      model: this.model,
      modelId: this.modelId,
    });
    this.breadcrumbTabulator.add({
      text: `Restore`,
      to: {
        name: "PageServiceModelBreadTabulatorRestore",
        params: {
          serviceKey: this.model.serviceKey,
          modelKey: this.model.key,
          modelId: this.modelId,
        },
      },
      exact: true,
    });

    if (this.model.apiUrls.apiRestoreUrl != "") {
      this.restoreUrl = `${this.$service[this.service.key]}${
        this.model.apiUrls.apiRestoreUrl
      }/${this.modelId}/restore`;
    } else {
      this.restoreUrl = `${
        this.$service[this.service.key]
      }/v1/en/console/tabulator/model/${this.model.key}/${
        this.modelId
      }/restore`;
    }

    this.api.setMethod(`POST`);
    this.api.setUrl(this.restoreUrl);
    this.api.setCallbackCompleted(() => {
      this.$router.push({
        name: "PageServiceModelBreadTabulatorBrowse",
        params: {
          serviceKey: this.model.serviceKey,
          modelKey: this.model.key,
        },
        query: {
          viewId: "all",
          tabIndex: 0,
        },
      });
      this.$store.dispatch("showMessage", {
        message: "Restore successfully.",
        messageType: "success",
        timeout: 2000,
      });
    });
  },
};
</script>
